import React, { } from "react";
import { useEventContext } from "../../context/EventContext";
import QuestionMessages from "../../components/QuestionMessages";
import { useQuestionsContext } from "../../context/QuestionsContext";
import { useUserContext } from "../../context/UserContext";
import { CPreloader } from "../../components/UI";
import "./style.scss";
import { useStreamContext } from "../../context/StreamContext";

export default ({ active, moduleRef, keyboardShowHandler }) => {
    const { user } = useUserContext();
    const { event } = useEventContext();
    const { stream } = useStreamContext();
    const {
        isShowBlockQuestions,
        flattenedMessages,
        sort, filter,
        sortValues, filterValues,
        updateSort, updateFilter,
        fixedMessages,
        unreadParentMessages,
        unreadChildrenMessages,
        updateMessage,
        isLoading,
        getMessagesMore,
        hasMore,
        isLoadingMore,
        onReadAll,
        messageSent,
        onWriteMessage,
        isAnswerSupported,
        scrollData,
        scrollAtStart,
        updateScrollData,
    } = useQuestionsContext();

    if (!isShowBlockQuestions) {
        return null;
    }

    const { likesEnabled, dislikesEnabled, avatarsDisabled } = event.moduleQuestion;

    return (
        <div className={`questions-container`}>
            {isLoading
                ? <CPreloader />
                : <QuestionMessages
                    currentUser={user}
                    flattenedMessages={flattenedMessages}
                    fixedMessages={fixedMessages}
                    sort={sort}
                    sortValues={sortValues}
                    updateSort={updateSort}
                    filter={filter}
                    filterValues={filterValues}
                    updateFilter={updateFilter}
                    likesEnabled={likesEnabled}
                    dislikesEnabled={dislikesEnabled}
                    updateMessage={updateMessage}
                    unreadParentMessages={unreadParentMessages}
                    unreadChildrenMessages={unreadChildrenMessages}
                    scrollData={scrollData}
                    updateScrollData={updateScrollData}
                    scrollAtStart={scrollAtStart}
                    avatarsDisabled={avatarsDisabled}
                    getMessagesMore={getMessagesMore}
                    hasMore={hasMore}
                    isLoadingMore={isLoadingMore}
                    moduleRef={moduleRef}
                    eventKey={event.eventKey}
                    onReadAll={onReadAll}
                    stream={stream}
                    isAnswerSupported={isAnswerSupported}
                    keyboardShowHandler={keyboardShowHandler}
                    messageSent={messageSent}
                    onWriteMessage={onWriteMessage}
                />
            }
        </div>
    );
}
